// by-category.js — Lógica de la sección "Compra por categoría"

const section             = document.querySelector('.byCategory');
// Prefijo del botón "Ir a colección", localizado vía data-goto-prefix (locales/*.json)
const GOTO_PREFIX         = section && section.dataset.gotoPrefix ? section.dataset.gotoPrefix : 'Ir a';
// Raíz de rutas localizada (p. ej. "" o "/en"), sin slash final para evitar "//".
const ROOT_URL            = section && section.dataset.rootUrl ? section.dataset.rootUrl.replace(/\/$/, '') : '';
// Sección Liquid que renderiza las tarjetas (ver sections/by-category-products.liquid).
const PRODUCTS_SECTION_ID = 'by-category-products';
const tabs               = document.querySelectorAll('.tab-btn');
const categoryContainer  = document.querySelector('.category-container');
const prevBtn            = document.querySelector('.category-prev');
const nextBtn            = document.querySelector('.category-next');
const collectionBtns     = document.querySelectorAll('.category-btn');

// Caché de pestañas: evita re-fetch al volver a una pestaña ya cargada
const cache = new Map();

// Actualiza visibilidad de flechas de scroll
function updateScrollButtons() {
  const { scrollLeft, scrollWidth, clientWidth } = categoryContainer;
  prevBtn.style.display = scrollLeft === 0 ? 'none' : 'flex';
  nextBtn.style.display = (scrollLeft + clientWidth >= scrollWidth - 1) ? 'none' : 'flex';
}

// Al hacer scroll manual
categoryContainer.addEventListener('scroll', updateScrollButtons, { passive: true });

// Actualiza texto y acción de los botones "Ir a colección"
function updateCollectionButtons(handle, name) {
  const url = `/collections/${handle}`;
  collectionBtns.forEach(btn => {
    btn.textContent = `${GOTO_PREFIX} ${name}`;
    btn.onclick       = () => { window.location.href = url; };
  });
}

// Lógica post-render compartida: adjunta handlers de imagen, resetea scroll y actualiza botones
function applyLoadedState(handle, name) {
  categoryContainer
    .querySelectorAll('.category-product-img img')
    .forEach(img => {
      const card = img.closest('.category-product');
      img.addEventListener('load', () => card.classList.add('loaded'));
      // Si la imagen ya estaba en caché del navegador
      if (img.complete) card.classList.add('loaded');
    });

  categoryContainer.scrollLeft = 0;
  updateScrollButtons();
  updateCollectionButtons(handle, name);
}

// Carga productos de una colección y genera las tarjetas
async function loadCollection(handle, name) {
  // Cache hit: reutiliza HTML ya generado sin re-fetch
  if (cache.has(handle)) {
    categoryContainer.innerHTML = cache.get(handle);
    applyLoadedState(handle, name);
    return;
  }

  try {
    // Section Rendering API: el HTML lo genera Liquid en el servidor, así que
    // respeta idioma y moneda/mercado del storefront (a diferencia de products.json).
    const resp = await fetch(`${ROOT_URL}/collections/${handle}?section_id=${PRODUCTS_SECTION_ID}`);
    if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
    const html = await resp.text();

    // La respuesta viene envuelta en <div id="shopify-section-...">; extraemos su interior.
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const rendered = doc.querySelector('.shopify-section');
    categoryContainer.innerHTML = rendered ? rendered.innerHTML : html;

    // Guarda en caché para re-clics futuros
    cache.set(handle, categoryContainer.innerHTML);

    applyLoadedState(handle, name);

  } catch (error) {
    console.error('Error cargando colección:', error);
  }
}

// Maneja clic en pestañas
tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    tabs.forEach(t => t.classList.remove('tab-active'));
    tab.classList.add('tab-active');
    loadCollection(tab.dataset.handle, tab.textContent.trim());
  });
});

// Flechas de navegación
nextBtn.addEventListener('click', () => {
  categoryContainer.scrollBy({ left: categoryContainer.clientWidth, behavior: 'smooth' });
});
prevBtn.addEventListener('click', () => {
  categoryContainer.scrollBy({ left: -categoryContainer.clientWidth, behavior: 'smooth' });
});

// La pestaña "novedades-7" ya viene renderizada por Liquid (SSR).
// Solo actualizamos los botones "Ir a colección" para el tab por defecto.
const defaultTab = document.querySelector('.tab-btn[data-handle="novedades-7"]');
if (defaultTab) {
  updateCollectionButtons('novedades-7', defaultTab.textContent.trim());
}

// Inicializa visibilidad de flechas para el contenido SSR
updateScrollButtons();
